import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import authJudgeModule from './modules/auth_judge'
// import folderListModule from './modules/folder_list'
import authModule from './modules/auth'

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    judge: authJudgeModule,
    auth: authModule,
    // folderList: folderListModule
  },
  strict: debug,
  plugins: debug ? [] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js